import { TransferForm, TransferSuccess, TransferWarning } from '@p2p/entities/transfer';
import { TGetOrderResponse } from '@p2p/services';
import { failStatuses, successStatuses } from '@p2p/shared/constants';
import { useParams } from 'react-router-dom';

import styles from './ThemedTransferPage.module.scss';

type ThemedTransferPageProps = {
  order?: TGetOrderResponse;
  openModal: () => void;
  isPlayed: boolean;
};

export const ThemedTransferPage = ({ order, openModal, isPlayed }: ThemedTransferPageProps) => {
  const { id } = useParams();
  if (!order || !id) {
    return <main className={styles.payment_page} />;
  }

  if (failStatuses.includes(String(order?.status))) {
    return <TransferWarning order={order} id={id} />;
  }

  if (successStatuses.includes(String(order?.status))) {
    return <TransferSuccess order={order} id={id} />;
  }

  return <TransferForm order={order} id={id} openModal={openModal} isPlayed={isPlayed} />;
};
